import { ImagePlaceholder } from "@/app/(components)/Basic/Image/types";
import { OgResult } from "@/shared/types";
import { ArtOrderFull } from "../art-order/types";
import {
  PostCommentDto,
  PostCommentWithRepliesDto,
} from "../comments/feed/types";
import { PostLikeDto } from "../likes/feed/types";
import { Nft } from "../nfts/types";
import { User } from "../users/types";

export interface FeedPostCreate {
  text?: string;
  repostId?: string;
  ignoredLinks?: string[];
}

export interface FeedPostDtoWithOgMetadata extends FeedPostDto {
  ogMetadata?: OgResult;
}

export interface FeedPostDto {
  id: string;
  author: User;
  text?: string;
  attachedNftId?: string;
  attachedNft?: Nft;
  gallery?: FeedPostImage[];
  repostId?: string;
  createdAt: string;
  ignoredLinks: string[];
  repost?: FeedPostDto;
  likes: PostLikeDto[];
  comments: PostCommentDto[];
  commentsWithReplies: PostCommentWithRepliesDto[];
  numberOfComments: number;
  numberOfReposts: number;
  artOrderId?: string;
  artOrder?: ArtOrderFull;
  portalMetadata?: PortalMetadata;
}

export interface FeedPostImage {
  id?: string;
  imageUrl: string;
  imagePlaceholder?: ImagePlaceholder;
  postId?: string;
}

export interface PortalMetadata {
  portal: NewsPortal;
  image: string;
  title: string;
  source: string;
}

export interface NewsPortal {
  name: string;
  imageUrl: string;
  url: string;
}

export enum FeedType {
  GLOBAL = "GLOBAL",
  NEWS = "NEWS",
  MY = "MY",
}
